import BrandRscore from './BrandRscore';

export default BrandRscore;
